import { DidomiContext } from 'app/app';
import { getDocCMS } from 'app/modules/cms/service/cmsService';
import { getDocument, isReady } from 'app/modules/cms/service/store/selectors';
import { getActiveSubscriptionByClient } from 'app/modules/contract/service';
import { DeviceType } from 'app/modules/rules/domain/Device.type';
import { RulesKeys } from 'app/modules/rules/domain/rules.keys';
import { RulesContext } from 'app/modules/rules/domain/RulesContext';
import { getAppDataConf } from 'app/modules/rules/service/rulesService';
import { getRulesDataByKey } from 'app/modules/rules/service/store/selectors';
import { getSellingPoint, sellectSellingPoint } from 'app/modules/sellingPoint/service/sellingPointService';
import PrivateRoute, { hasAnyAuthority } from 'app/shared/auth/private-route';
import PublicRoute from 'app/shared/auth/public-route';
import { ISpbNavbarItem, SpbLayout } from 'app/shared/components';
import DialogDesktop from 'app/shared/components/common/dialog/dialog';
import UnderConstruction from 'app/shared/components/common/under-construction/under-construction';
import Loader from 'app/shared/components/spb/loader/loader';
import { AUTHORITIES } from 'app/shared/config/constants';
import { IRootState } from 'app/shared/reducers';
import { componentDesktopImportName } from 'app/shared/util/desktop-methode-util';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { ContractDocumentsPage } from '../common/contract-documents/contract-documents';
import { Login } from './login/login';

import { getclaimsListBySubscriptionNumber } from 'app/modules/claim/service';
import ReturnArrow from 'app/shared/components/common/return-arrow';
import './app.desktop.style.scss';

const Routes = () => {
  const didomi = useContext(DidomiContext);
  const dispatch = useDispatch();
  const history = useHistory();
  const appStyle: any = useSelector<IRootState>(getDocument('app_global_type'));
  const sideNavData: any = useSelector<IRootState>(getDocument('generic_side_nav_v2'));
  interface LocationState {
    searchValue?: string;
  }

  const cmsIsReady: any = useSelector<IRootState>(isReady);
  const isAuthenticated: any = useSelector<IRootState>(state => state.authentication.isAuthenticated);
  const ClientAreaList = useSelector(getRulesDataByKey(RulesKeys.GET_CONF));
  const account: any = useSelector<IRootState>(state => state.authentication.account);
  const sellingPoints: any = useSelector<IRootState>(state => state.sellingPoint.sellingPoints);
  const sellingPointsLoading: any = useSelector<IRootState>(state => state.sellingPoint.loading);
  const connectedSellingPoint: any = useSelector<IRootState>(state => state.sellingPoint.connectedSellingPoint);
  const userAuthority = Object.keys(account).length !== 0 ? hasAnyAuthority([AUTHORITIES.IBAN_WRITE], account.authorities) : true;
  const [open, setOpen] = React.useState(false);
  const [ibanWriteNotifcation, setIbanWriteNotifcation] = useState(false);
  const configuration: any = useSelector<IRootState>(state => state.global.configuration);
  const dataConfList: any = useSelector<IRootState>(state => state.rules.dataConfList);
  const rulesDataResponse = useSelector(getRulesDataByKey(RulesKeys.GET_CONF));
  const location = useLocation<LocationState>();
  const claimList: any = useSelector<IRootState>(state => state.claim.claimsList);
  const claimLoading: any = useSelector<IRootState>(state => state.claim.loading);
  const claim: any = useSelector<IRootState>(state => state.claim.claimModel.claim);
  const [query, setQuery] = useState(new URLSearchParams(location.search));
  const [navBarItem, setNavBarItem] = useState(null);
  const ruleRootMap = Object.entries(ClientAreaList?.routerConfig || []) as [];
  const claimPage: any = useSelector<IRootState>(state => state.claim.page);
  const contractPage: any = useSelector<IRootState>(state => state.contract.page);
  const cms: any = useSelector<IRootState>(state => state.cms);
  const avatar: any = useSelector<IRootState>(state => state.global.avatar);


  const rulesContext: RulesContext = {
    key: RulesKeys.GET_CONF,
    entryDataRules: { deviceType: DeviceType.DESKTOP },
  };
  const rulesContextFooter: RulesContext = {
    key: RulesKeys.GET_FOOTER_CONF,
    entryDataRules: { deviceType: DeviceType.DESKTOP },
  };
  const [bgImg, setbgImg] = useState('');
  const [notificationMsg, setNotificationMsg] = useState("" as string);

  const dispatchSellingPoint = () => {
    if (
      isAuthenticated &&
      ClientAreaList !== undefined &&
      ClientAreaList?.constraint !== undefined &&
      ClientAreaList?.constraint.find(e => (e = 'iban_alert'))
    ) {
      dispatch(getSellingPoint());
    }
  };

  const handleSelectSellingPoint = (sellingPoint: any) => {
    dispatch(sellectSellingPoint(sellingPoint));
  };

  const selectItem = (item: ISpbNavbarItem) => {
    if (item.url.includes('https')) {
      window.location.href = item.url;
    } else {
      history.push(item.url);
    }
  };

  const renderSwitch = param => {
    const headerMessage = sideNavData?.data?.text_paths_messages?.find(x => x.path === param)?.text;

    switch (param) {
      case '/claims':
        if (!claimLoading && claimList) {
          return claimList?.length > 1
            ? headerMessage?.replace('{Mes/mon}', 'Mes').replace('{s}', 's')
            : headerMessage?.replace('{Mes/mon}', 'Mon').replace('{s}', '');
        }
        break;
      case '/contracts':
        return headerMessage;
        break;
      case '/contact':
        return headerMessage;
        break;
      default:
        return '';
    }
  };

  useEffect(() => {
    if (query.get('claimNumber') && query.get('action') === 'upload') {
      history.push(`/claims/${query.get('claimNumber')}`, { action: 'upload' });
    } else if (query.get('claimNumber') && query.get('action') === 'follow') {
      history.push(`/claims/${query.get('claimNumber')}`, { action: 'follow' });
    } else if (query.get('claimNumber') && query.get('action') === 'contact') {
      history.push(`/claims/${query.get('claimNumber')}`);
    } else if (query.get('claimNumber')) {
      history.push(`/claims`, { claimNumber: query.get('claimNumber'), action: 0 });
    } else if (query.get('documentName')) {
      history.push({
        pathname: '/document',
        state: { documentName: query.get('documentName'), default: query.get('default') },
      });
    }
  }, []);

  useEffect(() => {
    dispatch(getAppDataConf(rulesContext));
    dispatch(getAppDataConf(rulesContextFooter));
    dispatch(getDocCMS('desktop_contract_and_claim_status_v2'));
    if (rulesDataResponse?.dataRecoveryService?.find(service => service === 'GETGENEREICSIDENAV')) {
      dispatch(getDocCMS('generic_side_nav_v2'));
    }
  }, []);
  useEffect(() => {
    if (isAuthenticated && rulesDataResponse?.dataRecoveryService?.find(service => service === 'GetActiveSubscriptionList')) {
      dispatch(getActiveSubscriptionByClient());
    }
  }, []);

  useEffect(() => {
    setbgImg(appStyle?.data?.background_image?.url);
  }, [appStyle]);

  useEffect(() => {
    dispatchSellingPoint();
    setNavBarItem(ClientAreaList);
  }, [ClientAreaList, isAuthenticated]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, [window?.location?.href, claimPage, contractPage]);

  useEffect(() => {
    if (!(connectedSellingPoint && connectedSellingPoint.code)) {
      if (sellingPoints && sellingPoints.length > 1) {
        setOpen(true);
      }
      if (sellingPoints.length === 1) {
        dispatch(sellectSellingPoint(sellingPoints[0]));
      }
    }
  }, [sellingPoints]);

  useEffect(() => {
    if (
      !(connectedSellingPoint?.details !== undefined &&
      (connectedSellingPoint?.details || []).length !== 0 &&
      connectedSellingPoint?.details[0]?.bankInfos?.iban &&
      connectedSellingPoint?.details[0]?.bankInfos?.iban !== '') &&
      connectedSellingPoint !== undefined && connectedSellingPoint!== null &&
      Object.keys(connectedSellingPoint)?.length !== 0 &&
      isAuthenticated &&
      ClientAreaList !== undefined &&
      ClientAreaList?.constraint !== undefined &&
      ClientAreaList?.constraint.find(e => (e = 'iban_alert'))
    ) {
      setIbanWriteNotifcation(true);
      setNotificationMsg(appStyle?.data?.iban_message as string || "")
    } else{
      setIbanWriteNotifcation(false);
      setNotificationMsg("")
    }
  }, [(connectedSellingPoint?.details || [])[0]?.bankInfos?.iban,dataConfList]);
  

  return (
    <SpbLayout
      header={{
        visible: true,
        bgImage: bgImg,
        rulesDataResponse,
        sidNavData: sideNavData,
        DesktopType: rulesDataResponse?.settings.desktopType,
      }}
      footer={{
        visible: true,
        didomi,
        productCode: configuration?.productCode,
        footerItems: dataConfList.get('GET_CONF')?.composeApp?.FOOTER?.params?.FOOTER_NAV_ITEM?.navBarItemList,
        footerConstant: sideNavData?.data?.footer_items,
      }}
      navbar={{
        visible: false,
        sidNavData: sideNavData?.data,
        items: ClientAreaList?.composeApp?.HEADER?.params?.NAV_BAR_ITEM?.navBarItemList || [],
        selectItem,
      }}
      leftBg={{ visible: true, backgroundImage: cms?.documents?.app_global_type?.data?.left_image?.url }}
      footerNotification={{visible:ibanWriteNotifcation, msg:notificationMsg,action:(ibanWriteNotifcation && userAuthority) ? () => {
        history.push('/account');
      } : null,actionLabel:(ibanWriteNotifcation && userAuthority) ? "Saisir un IBAN" : "" }}
    >
      <DialogDesktop open={open} setOpen={setOpen} data={sellingPoints} avatar={avatar} selectSellingPoint={handleSelectSellingPoint} />

      {sellingPointsLoading && (
        <div className="dialog-loading">
          <Loader />
        </div>
      )}

      <div className="bg-image">
        {(history.location.pathname.includes('/contracts/') ||
          history.location.pathname.includes('/account-engine') ||
          history.location.pathname.includes('/contact')) && (
            <div className="">
              <ReturnArrow className="btn btn-back" previousLink="/contracts"></ReturnArrow>
            </div>
          )}
        {history.location.pathname.includes('/claims/') && (
          <div className="">
            <ReturnArrow
              className="btn btn-back"
              getPreviousStep={() => {
                if (claim?.subscriptionNumber) {
                  getclaimsListBySubscriptionNumber(claim?.subscriptionNumber);
                  history.push({ pathname: '/claims', state: { searchValue: claim?.subscriptionNumber } });
                }
              }}
            ></ReturnArrow>
          </div>
        )}
        <div className="bg-image-text">
          <h4>{renderSwitch(history.location.pathname)}</h4>
        </div>
      </div>

      <div className="view-routes">
        {!!cmsIsReady && (
          <Switch>
            {configuration?.specificRedirectUrl === '' && <PublicRoute path={'/signin'} component={Login} />}
            <PrivateRoute redirectionUrl={configuration?.specificRedirectUrl} path={'/document'} component={ContractDocumentsPage} />
            {ruleRootMap.map((value, index) => (
              <PrivateRoute
                redirectionUrl={configuration?.specificRedirectUrl}
                key={index}
                path={value[0]}
                exact
                component={componentDesktopImportName[value[1]]}
              />
            ))}
            <Route path="/charte-de-confidentialite" component={UnderConstruction} />
            <Route path="/conditions-generales-utilisation" component={UnderConstruction} />

            <Redirect to="/contracts" />
          </Switch>
        )}
      </div>
    </SpbLayout>
  );
};

export default Routes;
